const sections = Array.from(document.querySelectorAll(".js-icon-follow-mouse"));

if (typeof sections != "undefined" && sections != null && sections.length > 0) {
    iconFollowMouse();
}

function iconFollowMouse() {

    gsap.set(".js-icon", {
        xPercent: -50,
        yPercent: -50
    });

    for (let i = 0; i < sections.length; i++) {
        sections[i].addEventListener("mousemove", onMouseMove);
        sections[i].addEventListener("mouseleave", onMouseLeave);

        var rect = sections[i].getBoundingClientRect();

        var center = {
            w: Math.round(rect.width * 0.5),
            h: Math.round(rect.height * 0.5)
        };

        var trg = sections[i].querySelector(".js-icon");

        gsap.set(trg, {
            x: center.w,
            y: center.h
        });
    }
}

function onMouseMove(e) {

    var videoCursor = this.querySelector(".js-icon");

    gsap.to(videoCursor, 0.6, {
        x: e.offsetX,
        y: e.offsetY,
        ease: Power4.easeOut
    });
}

function onMouseLeave() {

    var rect = this.getBoundingClientRect();
    var center = {
        w: Math.round(rect.width * 0.5),
        h: Math.round(rect.height * 0.5)
    };
    var videoCursor = this.querySelector(".js-icon");

    gsap.to(videoCursor, 0.6, {
        x: center.w,
        y: center.h,
        ease: Back.easeOut.config(1.4)
    });
}
